import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { isUuid } from "../../../lib/ids";
import { GiftDetailScreen } from "../../../screens/gifts/gift-detail-screen";
import { giftDetailQuery } from "../../../screens/gifts/queries";
import { LoadErrorScreen, NotFoundScreen } from "../../../screens/invoices/shared";

export const Route = createFileRoute("/_authed/gifts/$giftId")({
  beforeLoad: ({ context, params }) => {
    // A malformed id is a 404 page, not a request (the API would answer 400 `invalid_id`).
    if (!isUuid(params.giftId)) throw notFound();
    if (!can(context.session.role, "gift:manage")) throw redirect({ to: "/" });
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(giftDetailQuery(params.giftId)),
  errorComponent: () => <LoadErrorScreen title={t.gifts.title} />,
  notFoundComponent: NotFoundScreen,
  component: () => {
    const { giftId } = Route.useParams();
    return <GiftDetailScreen giftId={giftId} />;
  },
});
